<ejs-dialog #detailDialog
  [visible]="visible"
  [isModal]="true"
  [showCloseIcon]="true"
  cssClass="modal-lg"
  (close)="close()">
  <ng-template #header>{{ 'i18n.domain.analytics.statistic-events.detail-dialog-title' | translate }}</ng-template>
  <ng-template #content>
    @if (event) {
      <div class="statistic-event-detail-content">
        <div class="row g-3 mb-4">
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.statistic-events.columns.vehicle-id' | translate }}</div>
            <div class="fw-semibold">{{ event.vehicleId }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.statistic-events.detail.trip-id' | translate }}</div>
            <div class="fw-semibold">{{ formatTripId(event.tripId) }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.statistic-events.detail.event-type' | translate }}</div>
            <div class="fw-semibold">{{ event.eventType }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.statistic-events.detail.module-name' | translate }}</div>
            <div class="fw-semibold">{{ event.moduleName }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.statistic-events.detail.occurred' | translate }}</div>
            <div class="fw-semibold">{{ formatDateTime(event.occurredUtc) }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.statistic-events.detail.severity' | translate }}</div>
            <div class="fw-semibold">{{ formatSeverity(event.severity) }}</div>
          </div>
        </div>

        <section>
          <h6 class="text-uppercase text-body-secondary small mb-2">{{ 'i18n.domain.analytics.statistic-events.detail.value-json' | translate }}</h6>
          <pre class="value-json-content">{{ formattedValueJson(event.valueJson) }}</pre>
        </section>
      </div>
    }
  </ng-template>
</ejs-dialog>
